(function () {
  'use strict';

  var AI_TRANSLATIONS = window.AiImageLabelTranslations || {
    close: 'Close',
    generated: {
      title: 'Mit KI generiert',
      text: 'Dieses Bild wurde ganz oder teilweise mithilfe künstlicher Intelligenz erstellt.'
    },
    modified: {
      title: 'Mit KI bearbeitet',
      text: 'Dieses Bild wurde ganz oder teilweise mithilfe künstlicher Intelligenz bearbeitet.'
    }
  };

  /*
   * Supported alt-text markers:
   *
   * [ai:generated] Description of the image
   * [ai:modified] Description of the image
   * [ai:edited] Description of the image
   */
  var ALT_MARKER_PATTERN =
    /^\s*\[ai:(generated|edited|modified)\]\s*/i;

  /*
   * Automatically label every image in a product gallery.
   * Images elsewhere still require an alt-text marker.
   */
  var AUTO_TAG_PRODUCT_GALLERIES = true;

  /*
   * Shopify article hero images are CSS backgrounds rather
   * than img elements, so they cannot carry an alt marker.
   * Always label blog hero images, article banners and
   * article-card images on the blog overview.
   */
  var AUTO_TAG_BLOG_BANNERS = true;

  /*
   * Automatically label images inside the rich-text body of
   * individual blog articles and collection pages.
   */
  var AUTO_TAG_EDITORIAL_CONTENT = true;

  function normalizeStatus(value) {
    value = (value || '')
      .toString()
      .trim()
      .toLowerCase();

    if (
      value === 'generated' ||
      value === 'ai-generated'
    ) {
      return 'generated';
    }

    if (
      value === 'modified' ||
      value === 'edited' ||
      value === 'ai-modified' ||
      value === 'ai-edited'
    ) {
      return 'modified';
    }

    return '';
  }

  function findLabelHost(node) {
    if (!node) {
      return null;
    }

    /*
     * Picture elements should be their own positioning
     * containers, including Collection banners.
     */
    if (
      node.tagName &&
      node.tagName.toLowerCase() === 'picture'
    ) {
      return node;
    }

    if (
      node.tagName &&
      node.tagName.toLowerCase() === 'img'
    ) {
      /*
       * Attach Rich Text badges to the individual
       * image instead of the full-width paragraph.
       */
      if (node.closest('.Rte')) {
        var figure = node.closest('figure');

        if (figure) {
          return figure;
        }

        var existingInlineHost = node.closest(
          '.AiImageInlineHost'
        );

        if (existingInlineHost) {
          return existingInlineHost;
        }

        if (node.parentNode) {
          var inlineHost = document.createElement('span');
          inlineHost.className = 'AiImageInlineHost';
          inlineHost.style.display = 'block';
          inlineHost.style.width = 'fit-content';
          inlineHost.style.maxWidth = '100%';
          inlineHost.style.marginLeft = 'auto';
          inlineHost.style.marginRight = 'auto';
          inlineHost.style.lineHeight = '0';

          node.parentNode.insertBefore(
            inlineHost,
            node
          );
          inlineHost.appendChild(node);

          return inlineHost;
        }

        return node.parentElement;
      }

      /*
       * Collection banner.
       */
      var collectionBanner = node.closest(
        '.CollectionBannerMeta__Picture'
      );

      if (collectionBanner) {
        return collectionBanner;
      }

      /*
       * Standard image components.
       */
      return (
        node.closest(
          '.grid-item, .AspectRatio, picture, a, div'
        ) ||
        node.parentElement
      );
    }

    return node;
  }

  function isFirstProductGalleryImage(image) {
    var firstSlide = image.closest(
      '.Product__SlideItem[data-variant-id], ' +
      '.Product__SlideItem[data-image-position="0"], ' +
      '.Product__SlideItem[data-image-position-ignoring-video="0"]'
    );

    return !!(
      firstSlide &&
      firstSlide.closest('.Product__Gallery')
    );
  }

  function applyAltMarker(image) {
    if (
      !image ||
      !image.tagName ||
      image.tagName.toLowerCase() !== 'img'
    ) {
      return;
    }

    var alt = image.getAttribute('alt') || '';
    var marker = alt.match(ALT_MARKER_PATTERN);

    /*
     * Primary and variant-specific product packshots must
     * never display an AI badge. The selected variant can
     * start the gallery at a position other than zero.
     */
    if (isFirstProductGalleryImage(image)) {
      image.removeAttribute('data-ai');

      if (marker) {
        image.setAttribute(
          'alt',
          alt.replace(ALT_MARKER_PATTERN, '').trim()
        );
      }

      return;
    }

    /*
     * An explicit data-ai attribute is also treated
     * as an intentional opt-in.
     */
    if (image.hasAttribute('data-ai')) {
      return;
    }

    var pathname = window.location.pathname;
    var isBlogArticle =
      /\/blogs\/[^/]+\/[^/]+\/?$/.test(pathname);
    var isCollectionPage =
      /\/collections\/[^/]+\/?$/.test(pathname);

    /*
     * Blog and collection rich-text images are always
     * treated as AI-generated. Explicit alt markers still
     * take precedence and can mark an image as modified.
     */
    if (
      !marker &&
      AUTO_TAG_EDITORIAL_CONTENT &&
      (isBlogArticle || isCollectionPage) &&
      image.closest('.Rte')
    ) {
      image.setAttribute(
        'data-ai',
        'generated'
      );

      return;
    }

    /*
     * Product gallery images are automatically treated
     * as AI-generated unless their alt text contains an
     * explicit generated/modified marker.
     */
    if (
      !marker &&
      AUTO_TAG_PRODUCT_GALLERIES &&
      image.closest(
        '.Product__Gallery, .Product__Slideshow, .PDPSw__Img'
      )
    ) {
      image.setAttribute(
        'data-ai',
        'generated'
      );

      return;
    }

    /*
     * No marker means no AI badge.
     */
    if (!marker) {
      return;
    }

    var status = normalizeStatus(marker[1]);

    if (!status) {
      return;
    }

    image.setAttribute('data-ai', status);

    /*
     * Remove the internal marker from the rendered
     * accessibility description.
     */
    image.setAttribute(
      'alt',
      alt.replace(ALT_MARKER_PATTERN, '').trim()
    );
  }

  function closeModal() {
    var modal = document.querySelector(
      '.AiImageModal'
    );

    if (!modal) {
      return;
    }

    modal.setAttribute(
      'aria-hidden',
      'true'
    );

    document.documentElement.classList.remove(
      'AiImageModalOpen'
    );
  }

  function getModal() {
    var modal = document.querySelector(
      '.AiImageModal'
    );

    if (modal) {
      return modal;
    }

    modal = document.createElement('div');
    modal.className = 'AiImageModal';

    modal.setAttribute(
      'aria-hidden',
      'true'
    );

    modal.innerHTML =
      '<div class="AiImageModal__Dialog" role="dialog" aria-modal="true" aria-labelledby="AiImageModalTitle">' +
        '<header class="AiImageModal__Header">' +
          '<h2 id="AiImageModalTitle" class="AiImageModal__Title"></h2>' +
          '<button class="AiImageModal__Close" type="button" aria-label="Close">&times;</button>' +
        '</header>' +
        '<div class="AiImageModal__Content">' +
          '<p></p>' +
        '</div>' +
      '</div>';

    modal.addEventListener(
      'click',
      function (event) {
        if (event.target === modal) {
          closeModal();
        }
      }
    );

    modal
      .querySelector('.AiImageModal__Close')
      .addEventListener(
        'click',
        closeModal
      );

    document.body.appendChild(modal);

    return modal;
  }

  function openModal(status) {
    var disclosure = AI_TRANSLATIONS[status];

    if (!disclosure) {
      return;
    }

    var modal = getModal();

    modal.querySelector(
      '.AiImageModal__Title'
    ).textContent = disclosure.title;

    modal.querySelector(
      '.AiImageModal__Content p'
    ).textContent = disclosure.text;

    modal.querySelector(
      '.AiImageModal__Close'
    ).setAttribute(
      'aria-label',
      AI_TRANSLATIONS.close
    );

    modal.setAttribute(
      'aria-hidden',
      'false'
    );

    document.documentElement.classList.add(
      'AiImageModalOpen'
    );

    modal.querySelector(
      '.AiImageModal__Close'
    ).focus();
  }

  function ensureLabel(node) {
    if (
      !node ||
      !node.getAttribute
    ) {
      return;
    }

    var status = normalizeStatus(
      node.getAttribute('data-ai')
    );

    var disclosure =
      AI_TRANSLATIONS[status];

    var host = findLabelHost(node);

    if (!disclosure || !host) {
      return;
    }

    host.setAttribute(
      'data-ai-label-ready',
      ''
    );

    if (
      window.getComputedStyle(host).position ===
      'static'
    ) {
      host.classList.add(
        'AiImageLabelHost--positioned'
      );
    }

    var label = null;

    for (
      var i = 0;
      i < host.children.length;
      i += 1
    ) {
      if (
        host.children[i].classList &&
        host.children[i].classList.contains(
          'AiImageLabel'
        )
      ) {
        label = host.children[i];
        break;
      }
    }

    if (!label) {
      label = document.createElement('span');
      label.className = 'AiImageLabel';

      label.setAttribute(
        'role',
        'button'
      );

      label.setAttribute(
        'tabindex',
        '0'
      );

      label.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();

          openModal(
            label.getAttribute(
              'data-ai-status'
            )
          );
        }
      );

      label.addEventListener(
        'keydown',
        function (event) {
          if (
            event.key === 'Enter' ||
            event.key === ' '
          ) {
            event.preventDefault();
            event.stopPropagation();

            openModal(
              label.getAttribute(
                'data-ai-status'
              )
            );
          }
        }
      );

      host.appendChild(label);
    }

    label.setAttribute(
      'data-ai-status',
      status
    );

    label.setAttribute(
      'aria-label',
      disclosure.title
    );

    label.textContent = 'AI';
  }

  function applyAutomaticBlogBanner(root) {
    if (
      !AUTO_TAG_BLOG_BANNERS ||
      !/\/blogs\/[^/]+(?:\/|$)/.test(
        window.location.pathname
      )
    ) {
      return;
    }

    var banners = [];

    if (
      root.matches &&
      root.matches(
        '.Article__ImageWrapper, ' +
        '.ImageHero, ' +
        '.ArticleItem__ImageWrapper'
      )
    ) {
      banners.push(root);
    }

    if (root.querySelectorAll) {
      var descendants = root.querySelectorAll(
        '.Article__ImageWrapper, ' +
        '.ImageHero, ' +
        '.ArticleItem__ImageWrapper'
      );

      for (
        var i = 0;
        i < descendants.length;
        i += 1
      ) {
        banners.push(descendants[i]);
      }
    }

    for (
      var j = 0;
      j < banners.length;
      j += 1
    ) {
      banners[j].setAttribute(
        'data-ai',
        'generated'
      );
      ensureLabel(banners[j]);
    }
  }

  function refresh(root) {
    root = root || document;

    applyAutomaticBlogBanner(root);

    /*
     * Process the root itself if it is an image.
     */
    if (
      root.tagName &&
      root.tagName.toLowerCase() === 'img'
    ) {
      applyAltMarker(root);
      ensureLabel(root);
    }

    /*
     * Process descendant images.
     */
    var images =
      root.querySelectorAll('img');

    for (
      var i = 0;
      i < images.length;
      i += 1
    ) {
      applyAltMarker(images[i]);

      if (images[i].hasAttribute('data-ai')) {
        ensureLabel(images[i]);
      }
    }

    /*
     * Support intentionally rendered data-ai elements.
     */
    var items =
      root.querySelectorAll('[data-ai]');

    for (
      var j = 0;
      j < items.length;
      j += 1
    ) {
      ensureLabel(items[j]);
    }
  }

  function init() {
    refresh(document);

    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'Escape') {
          closeModal();
        }
      }
    );

    if (!window.MutationObserver) {
      return;
    }

    var observer = new MutationObserver(
      function (mutations) {
        for (
          var i = 0;
          i < mutations.length;
          i += 1
        ) {
          var mutation = mutations[i];

          if (mutation.type === 'attributes') {
            if (
              mutation.attributeName === 'alt'
            ) {
              applyAltMarker(
                mutation.target
              );

              if (
                mutation.target.hasAttribute(
                  'data-ai'
                )
              ) {
                ensureLabel(
                  mutation.target
                );
              }
            }

            if (
              mutation.attributeName === 'data-ai'
            ) {
              ensureLabel(
                mutation.target
              );
            }
          }

          for (
            var j = 0;
            j < mutation.addedNodes.length;
            j += 1
          ) {
            var node =
              mutation.addedNodes[j];

            if (node.nodeType !== 1) {
              continue;
            }

            refresh(node);
          }
        }
      }
    );

    observer.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'alt',
          'data-ai'
        ]
      }
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
}());
